import { WirPauseStates } from 'types/wellGuardian';

const ALL_WIR = 'ALL';

export const getFilterSites = (
  x: any,
  type: string,
  siteFilter: string,
  interventionStatusFilter: string | undefined,
) => {
  if (type === 'list') {
    switch (siteFilter === ALL_WIR) {
      case x && interventionStatusFilter === WirPauseStates.ARCHIVED:
        return x.pausedState === WirPauseStates.ARCHIVED;
      case x && interventionStatusFilter !== WirPauseStates.ARCHIVED:
        return x.pausedState !== WirPauseStates.ARCHIVED;
    }
  } else if (type === 'schedule') {
    switch (siteFilter === ALL_WIR) {
      case siteFilter === ALL_WIR:
        return x && x.pausedState !== WirPauseStates.ARCHIVED;
      case siteFilter !== ALL_WIR:
        return x.site === siteFilter && x.pausedState !== WirPauseStates.ARCHIVED;
    }
  } else {
    switch (siteFilter === ALL_WIR) {
      case x.site === siteFilter && interventionStatusFilter === WirPauseStates.ARCHIVED:
        return x.pausedState === WirPauseStates.ARCHIVED;
      case x.site !== siteFilter && interventionStatusFilter !== WirPauseStates.ARCHIVED:
        return x.pausedState !== WirPauseStates.ARCHIVED;
    }
  }
};
